
import { loadMessages, locale } from 'devextreme/localization';
import { dxCommonMessages } from './components/dx-common.i18n';
import { dxFileUploaderMessages } from './components/dx-file-uploader.i18n';
import { dxHtmlEditorMessages } from './components/dx-html-editor.i18n';

export const devExtremeMessages = {
  'pt-BR': {
    ...dxCommonMessages['pt-BR'],
    ...dxHtmlEditorMessages['pt-BR'],
    ...dxFileUploaderMessages['pt-BR']
  },
  'en-US': {
    ...dxCommonMessages['en-US'],
    ...dxHtmlEditorMessages['en-US'],
    ...dxFileUploaderMessages['en-US']
  },
  'es-ES': {
    ...dxCommonMessages['es-ES'],
    ...dxHtmlEditorMessages['es-ES'],
    ...dxFileUploaderMessages['es-ES']
  }
};

export function configureDevExtremeLocalization(language: string): void {
  loadMessages(devExtremeMessages);
  if (devExtremeMessages[language]) {
    locale(language);
  } else {
    console.warn(`Language '${language}' not supported. Using 'en-US' as default.`);
    locale('en-US');
  }
}